import MyselfContact from 'components/contacts/MyselfContact';
import React from 'react';

const MyselfContactPage = () => {
  return (
    <div className="leftContent">
      <MyselfContact />
    </div>
  );
};

export default MyselfContactPage;
